import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '../../accordion/accordion';
import CollapsingDescription from '../../elements-description/CollapsingDescription';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Stereo } from '../../icons';
import { EVENT_FAQ_CONST } from '../data/constants';
import { eventFaqDefinition, miscEventFaqDefinitions, category_labels } from '../data/eventFaqDefinition';

const AVMusicContent = ({ faqData = {}, availableEquipment, hasOtherAVEquipment, hasRulesForAV, avRulesSelected, AVRulesProhibited, intl }) => {
  const { MISC_AV_EQUIPMENT } = EVENT_FAQ_CONST;
  const label = <FormattedMessage
    id={category_labels.av_music.id}
    defaultMessage={category_labels.av_music.defaultMessage}
  />;
  return (
    <div className="EventFAQ">
      <Accordion
        header={
          <div className="flex middle">
            <Stereo height={24} width={24} className="margin-sm-right" />
            <div className="h6 margin-md-left padding-xs-top padding-xs-bottom faq-section">{label}</div>
          </div>
        }
        onOpenCallback={() => {
          analyticsIntegrations.trackEvent('Listing section expanded', {
            user_id: faqData.userID,
            listing_id: faqData.listingID,
            section: 'AV Music'
          });
        }}
      >
        <div className="margin-lg-bottom section-indent event-faq-section ">
          <div className="faq-label heavier margin-md-bottom">
            {intl.formatMessage(miscEventFaqDefinitions.available_av_equipment)}
          </div>
          {availableEquipment.map((equipment, key) => (
            <div className="faq-body flex margin-md-bottom" key={key}>
              <div className="flex-basis-90">
                <div>{intl.formatMessage(eventFaqDefinition.av_music.provided_av_equipment[equipment])}</div>
                {faqData[equipment].description && <CollapsingDescription description={faqData[equipment].description} textSmall/>}
              </div>
            </div>))
          }
          {hasOtherAVEquipment && (<div>
            <div>
              <FormattedMessage
                id={eventFaqDefinition.av_music.provided_av_equipment[MISC_AV_EQUIPMENT].id}
                defaultMessage={eventFaqDefinition.av_music.provided_av_equipment[MISC_AV_EQUIPMENT].defaultMessage}
              />
            </div>
            <div className="text-gray-600 description text-small">
              {faqData[MISC_AV_EQUIPMENT].description
                && <CollapsingDescription description={faqData[MISC_AV_EQUIPMENT].description} />}
            </div>
          </div>)}
          {hasRulesForAV && <hr className="margin-lg-top"/>}
        </div>
        {hasRulesForAV && <div className='section-indent margin-lg-bottom'>
          <div className="faq-label heavier margin-md-bottom">
            {intl.formatMessage(miscEventFaqDefinitions.av_rules)}
          </div>
          {avRulesSelected.map((activity, key) => (
            <div className="faq-label margin-md-bottom" key={key}>
              {intl.formatMessage(eventFaqDefinition.av_music.av_equipment_rules[activity])}
            </div>))}
          {AVRulesProhibited.map((activity, key) => (
            <div className="faq-label text-gray-600 margin-md-bottom strike-through" key={key}>
              {intl.formatMessage(eventFaqDefinition.av_music.av_equipment_rules[activity])}
            </div>))}
        </div>}
      </Accordion>
    </div>
  );
};

AVMusicContent.propTypes = {
  faqData: PropTypes.object,
  availableEquipment: PropTypes.array,
  hasOtherAVEquipment: PropTypes.bool,
  hasRulesForAV: PropTypes.bool,
  avRulesSelected: PropTypes.array,
  AVRulesProhibited: PropTypes.array,
  intl: PropTypes.object
};

export default injectIntl(AVMusicContent);
